<template>
  <v-card>
    <v-toolbar color="secondary" class="elevation-0">
      <v-toolbar-title> Invoices </v-toolbar-title>
    </v-toolbar>
    <v-card-actions>
      <div>
        <v-menu :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              dense
              outlined
              :value="startDate"
              prepend-inner-icon="mdi-calendar-clock"
              append-inner-icon="mdi-menu-down"
              class="mx-5"
              style="height: 40px; min-width: 180px"
              label="From"
              hide-details
            />
          </template>
          <v-list class="pa-0" style="max-width: fit-content">
            <v-list-item class="pa-0">
              <v-list-item-title>
                <v-date-picker
                  v-model="startDate"
                  show-adjacent-months
                  :max="endDate"
                />
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div>
        <v-menu :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              dense
              outlined
              :value="endDate"
              prepend-inner-icon="mdi-calendar-clock"
              append-inner-icon="mdi-menu-down"
              class="mx-5"
              style="height: 40px; min-width: 180px"
              label="To"
              hide-details
            />
          </template>
          <v-list class="pa-0" style="max-width: fit-content">
            <v-list-item class="pa-0">
              <v-list-item-title>
                <v-date-picker
                  v-model="endDate"
                  show-adjacent-months
                  :min="startDate"
                />
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        outlined
        dense
        hide-details
      ></v-text-field>
    </v-card-actions>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        dense
        :items-per-page="15"
      >
        <template v-slot:[`item.amount`]="{ item }">
          {{ item.amount }} {{ item.currency }}
        </template>
        <template v-slot:[`item.paid`]="{ item }">
          <v-icon v-if="item.paid"> mdi-check </v-icon>
          <v-icon v-if="!item.paid"> mdi-close </v-icon>
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-btn icon @click="showDetails(item)">
            <v-icon>mdi-clipboard-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="detailsDialog" width="600">
      <v-card>
        <v-toolbar color="secondary" class="elevation-0">
          <v-toolbar-title>
            {{ this.item?.tenant }} - {{ this.item?.created }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5 px-5">
          <pre class="text-body-1">{{
            JSON.stringify(this.item?.details, null, 2)
          }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate, endOfDay } from "@/lib/utils";

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const defaultStart = new Date(new Date().getTime() - 365 * DAY_IN_MS);
const defaultEnd = new Date();

export default {
  props: ["tenant_uid"],
  data: () => ({
    loading: false,
    detailsDialog: false,
    item: null,
    startDate: formatDate(defaultStart),
    endDate: formatDate(defaultEnd),
    search: null,
    headers: [
      { text: "Tenant", value: "tenant" },
      { text: "Amount", value: "amount" },
      { text: "Issued", value: "created" },
      { text: "Paid", value: "paid" },
      { text: "Details", value: "details" },
    ],
  }),

  watch: {
    detailDialog(val) {
      if (!val) this.item = null;
    },
  },

  computed: {
    ...mapGetters(["invoices", "tenants"]),
    items() {
      return this.invoices
        ?.filter((i) => !this.tenant_uid || i.tenant_uid === this.tenant_uid)
        .filter(
          (i) =>
            new Date(i.created_at) >= new Date(this.startDate) &&
            new Date(i.created_at) < endOfDay(this.endDate)
        )
        .map((i) => ({
          tenant: this.tenants?.find((t) => t.uid === i.tenant_uid)?.name,
          amount: i.amount,
          currency: i.currency_code,
          paid: i.paid,
          created: new Date(i.created_at).toLocaleDateString(),
          details: i,
        }));
    },
  },

  methods: {
    showDetails(item) {
      this.item = item;
      this.detailsDialog = true;
    },
    openDetail(item) {
      this.$router.push("/instances/" + item.details.uid);
    },
  },
};
</script>
